<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px">
        <div>
          <a-button type="primary" @click="showModal">新增大学</a-button>
        </div>
        <div>
          <label>搜索：</label>
          <a-select v-model="selectVal" style="width: 120px">
            <a-select-option value="name">大学名称</a-select-option>
            <a-select-option value="code">大学代码</a-select-option>
          </a-select>
          <a-input-search 
            placeholder="请输入搜索内容" 
            v-model="searchInput" 
            style="width: 300px" 
            @search="onSearch" 
            class="mr10px"
          />
        </div>
      </div>
      <a-table
        :columns="columns"
        :data-source="data"
        :rowKey="'id'"
        :pagination="{pageSize: page.pageSize, total}"
        @change="changePage"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch 
            :checked="text === 1" 
            @change="(checked) => handleStatusChange(checked, record)"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-space>
            <a @click="() => editItem(record)">编辑</a>
            <a-popconfirm
              title="确定要删除这条记录吗?"
              @confirm="() => deleteItem(record.id)"
              ok-text="确定"
              cancel-text="取消"
            >
              <a href="#">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </div>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model 
        ref="ruleForm" 
        :model="form" 
        :rules="rules" 
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="大学名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入大学名称" />
        </a-form-model-item>
        <a-form-model-item label="所在城市" prop="city_name">
          <a-cascader
            v-model="selectedCity"
            :options="provinceCityOptions"
            :field-names="{ label: 'name', value: 'code', children: 'children' }"
            placeholder="请选择所在城市"
            style="width: 100%"
            @change="handleCityChange"
            change-on-select
            :get-popup-container="trigger => trigger.parentNode"
          />
        </a-form-model-item>
        <a-form-model-item label="学校代码" prop="code">
          <a-input v-model="form.code" placeholder="请输入学校代码" />
        </a-form-model-item>
        <a-form-model-item label="学校级别" prop="level">
          <a-select v-model="form.level" placeholder="请选择学校级别" style="width: 100%">
            <a-select-option value="985">985</a-select-option>
            <a-select-option value="211">211</a-select-option>
            <a-select-option value="双一流">双一流</a-select-option>
            <a-select-option value="普通本科">普通本科</a-select-option>
            <a-select-option value="专科">专科</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="学校Logo" prop="logo">
          <a-upload
            name="file"
            list-type="picture-card"
            class="logo-uploader"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            @change="handleLogoChange"
          >
            <img v-if="form.logo" :src="form.logo" alt="logo" style="max-width: 100px; max-height: 100px;" />
            <div v-else>
              <a-icon :type="uploading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传Logo
              </div>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="详细地址" prop="address">
          <a-input v-model="form.address" placeholder="请输入学校详细地址" />
        </a-form-model-item>
        <a-form-model-item label="学校简介" prop="description">
          <a-textarea 
            v-model="form.description" 
            placeholder="请输入学校简介" 
            :auto-size="{ minRows: 3, maxRows: 6 }"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-switch 
            v-model="form.status" 
            :checked-children="'启用'" 
            :un-checked-children="'禁用'"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  { title: '大学名称', dataIndex: 'name', align: 'center' },
  { title: '学校代码', dataIndex: 'code', align: 'center' },
  { 
    title: '所在地区', 
    dataIndex: 'location', 
    align: 'center',
    customRender: (text, record) => {
      return `${record.province_name} ${record.city_name}`;
    }
  },
  { title: '学校级别', dataIndex: 'level', align: 'center' },
  { 
    title: '状态', 
    dataIndex: 'status', 
    align: 'center',
    scopedSlots: { customRender: 'status' } 
  },
  { 
    title: '创建时间', 
    dataIndex: 'createTime', 
    align: 'center',
    customRender: text => text || '-' 
  },
  { 
    title: '操作', 
    dataIndex: 'operation', 
    align: 'center',
    width: '180px',
    scopedSlots: { customRender: 'operation' } 
  },
];

// 导入完整的省市区数据
import { cityOptions } from '@/utils/cityData';

import * as http from '@/libs/analysis'

export default {
  name: 'universityList',
  data() {
    return {
      data: [],
      columns,
      cityOptions,
      searchInput: '',
      selectVal: 'name',
      visible: false,
      confirmLoading: false,
      isEdit: false,
      currentId: null,
      uploading: false,
      selectedCity: [],
      form: {
        name: '',
        code: '',
        level: '',
        logo: '',
        province_name: '',
        province_id: '',
        city_name: '',
        city_id: '',
        description: '',
        address: '',
        status: true
      },
      rules: {
        name: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入学校代码', trigger: 'blur' }],
        level: [{ required: true, message: '请选择学校级别', trigger: 'change' }],
        province_id: [{ required: true, message: '请选择省份', trigger: 'change' }],
        city_id: [{ required: true, message: '请选择城市', trigger: 'change' }]
      },
      page: {
        pageSize: 10,
        page: 1
      },
      total: 0,
      filter: {}
    }
  },
  computed: {
    modalTitle() {
      return this.form.id ? '编辑大学' : '新增大学';
    },
    // 处理只显示省和市两级的选项
    provinceCityOptions() {
      return this.cityOptions.map(province => ({
        ...province,
        code: String(province.code || ''),
        children: (province.children || []).map(city => ({
          ...city,
          code: String(city.code || '')
        }))
      }));
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        ...this.page,
        ...this.filter,
        [this.selectVal]: this.searchInput || undefined
      };
      
      http.getUniversityList(params).then(res => {
        this.data = res.list || [];
        this.total = res.total || 0;
      });
    },
    
    onSearch() {
      this.page.page = 1;
      this.getData();
    },
    
    changePage(pagination) {
      this.page.page = pagination.current;
      this.getData();
    },
    
    // 文件上传前检查
    beforeUpload(file) {
      const isImage = file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB!');
      }
      return isImage && isLt2M;
    },
    
    // 处理logo上传
    handleLogoChange(info) {
      if (info.file.status === 'uploading') {
        this.uploading = true;
        return;
      }
      if (info.file.status === 'done') {
        // 这里应该是上传成功后的回调，实际项目中替换为真实的图片URL
        // this.form.logo = info.file.response.url;
        this.form.logo = 'https://example.com/upload/' + info.file.name;
        this.uploading = false;
      }
      if (info.file.status === 'error') {
        this.uploading = false;
        this.$message.error('上传失败');
      }
    },
    
    showModal() {
      this.isEdit = false;
      this.form = {
        name: '',
        city_name: [],
        code: '',
        level: '',
        logo: '',
        description: '',
        address: '',
        status: true,
      };
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
      });
    },
    // handleCityChange(value, selectedOptions) {
    //   if (selectedOptions && selectedOptions.length === 2) {
    //     this.form.province_id = selectedOptions[0].code;
    //     this.form.province_name = selectedOptions[0].name;
    //     this.form.city_id = selectedOptions[1].code;
    //     this.form.city_name = selectedOptions[1].name;
    //   }
    // },
    handleCityChange(value, selectedOptions) {
      console.log('City changed:', { value, selectedOptions });
      if (selectedOptions && selectedOptions.length > 0) {
        const province = selectedOptions[0];
        const city = selectedOptions[1] || province;
        
        this.form.province_id = province.code;
        this.form.province_name = province.name;
        this.form.city_id = city.code;
        this.form.city_name = city.name;
      } else {
        this.form.province_id = '';
        this.form.province_name = '';
        this.form.city_id = '';
        this.form.city_name = '';
      }
    },
  
    editItem(record) {
      this.isEdit = true;
      this.currentId = record.id;
      this.form = { ...record };
      
      console.log('Editing record:', record);

      const provinceId = String(record.province_id || '');
      const cityId = String(record.city_id || '');
      
      // 设置城市选择器的值
      this.selectedCity = [];
      if (provinceId) {
        this.selectedCity.push(provinceId);
        if (cityId) {
          this.selectedCity.push(cityId);
        }
      }
      console.log('Set selectedCity to:', this.selectedCity);
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm?.clearValidate();
      });
    },
    resetForm() {
      this.selectedCity = [];
      this.form = {
        name: '',
        code: '',
        level: '',
        logo: '',
        province_name: '',
        province_id: '',
        city_name: '',
        city_id: '',
        description: '',
        address: '',
        status: true,
        selectedCity: []
      };
      this.$refs.ruleForm?.clearValidate();
    },
    async handleOk() {
      try {
        this.$refs.ruleForm.validate(async valid => {
          if (!valid) return;
          
          this.confirmLoading = true;
          const formData = {
            ...this.form,
            // Don't include selectedCity in the final submission
            selectedCity: undefined
          };
          
          let res;
          if (this.isEdit) {
            http.addUniversity({ ...formData, id: this.currentId }).then(res => {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功');
              this.visible = false;
              this.getData();
              this.resetForm();
            });
          } else {
            http.addUniversity(formData).then(res => {
              this.$message.success(this.isEdit ? '更新成功' : '添加成功');
              this.visible = false;
              this.getData();
              this.resetForm();
            });
          }
          
        });
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error(this.isEdit ? '更新失败' : '添加失败');
      } finally {
        this.confirmLoading = false;
      }
    },
    
    handleCancel() {
      this.visible = false;
      this.$refs.ruleForm.resetFields();
    },
    
    deleteItem(id) {
      http.deleteUniversity({ id }).then(() => {
        this.$message.success('删除成功');
        this.getData();
      });
    },
    
    handleStatusChange(checked, record) {
      const status = checked ? 1 : 0;
      http.updateUniversityStatus({ id: record.id, status }).then(() => {
        this.$message.success('状态更新成功');
        record.status = status;
      });
    }
  }
}
</script>

<style scoped>
.filter {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.mr10px {
  margin-right: 10px;
}
</style>
